import { render, staticRenderFns } from "./GivingBack.vue?vue&type=template&id=45fb323f&scoped=true"
import script from "./GivingBack.vue?vue&type=script&lang=ts"
export * from "./GivingBack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb323f",
  null
  
)

export default component.exports